import { Carousel } from "antd";
import { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import classNames from "classnames";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
const PptPreview = ({ pptImgList }) => {
  const [curPage, setCurPage] = useState(1);
  const carouselRef = useRef(null)
  const afterChange = (e) => {
    setCurPage(e + 1);
  };
  const preChange = ()=>{
    carouselRef.current.prev()
    setCurPage(curPage-1)
  }
  const nextChange = ()=>{
    carouselRef.current.next()
    setCurPage(curPage+1)
  }

  useEffect(()=>{
    setCurPage(1)
  },[pptImgList])
  return (
    <div>
      <Carousel ref={carouselRef} draggable afterChange={afterChange} arrows infinite={false}>
        {pptImgList.map((item) => {
          return (
            <div>
              <img style={{ width: "100%" }} src={item} alt="" />
            </div>
          );
        })}
      </Carousel>
      <div className={classNames(styles.pageWrap, "flex_box", "flex_center","align_center")}>
        <div>{curPage}/{pptImgList.length}</div>
        <div className={styles.pageBtn}>
          <Button icon={<LeftOutlined />} onClick={preChange} type="text" disabled={curPage === 1 ? true : false}></Button>
          <Button icon={<RightOutlined />} onClick={nextChange} type="text" disabled={curPage === pptImgList.length ? true : false}></Button>
        </div>
      </div>
    </div>
  );
};

export default PptPreview;
